import { createApi } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../utils/helper";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";

export const guidelineApiService = createApi({
  reducerPath: "guidelineApi",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["Guideline"],
  endpoints: (builder) => ({
    getGuideline: builder.query({
      query: ({ id, params }) => {
        const query = queryParams(params);
        if (id) return `guideline/get/${id}${query}`;
        return `guideline/get${query}`;
      },
      keepUnusedDataFor: 0,
      providesTags: ["Guideline"],
    }),
    createGuideline: builder.mutation({
      query: ({ payload, params }) => {
        const query = queryParams(params);
        return {
          url: `guideline/create${query}`,
          method: "POST",
          body: payload,
        };
      },
      invalidatesTags: ["Guideline"],
    }),
    updateGuideline: builder.mutation({
      query: ({ id, body, params }) => {
        const query = queryParams(params);
        return {
          url: `guideline/${id}${query}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["Guideline"],
    }),
    postComment: builder.mutation({
      query: ({ payload, params }) => {
        const query = queryParams(params);
        return {
          url: `guideline/comment${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
    updateComment: builder.mutation({
      query: ({ id, body, params }) => {
        const query = queryParams(params);
        return {
          url: `guideline/comment/${id}${query}`,
          method: "PUT",
          body,
        };
      },
    }),
  }),
});

export const {
  useCreateGuidelineMutation,
  useGetGuidelineQuery,
  useUpdateGuidelineMutation,
  usePostCommentMutation,
  useUpdateCommentMutation,
} = guidelineApiService;
